import { IForm } from '@/components/types'

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'roleName',
      type: 'input',
      label: '角色名',
      placeholder: '请输入角色名'
    },
    {
      field: 'displayName',
      type: 'input',
      label: '显示姓名',
      placeholder: '请输入显示名'
    },
    // {
    //   field: 'status',
    //   type: 'select',
    //   label: '角色状态',
    //   placeholder: '请选择角色状态',
    //   options: [
    //     { title: '正常', value: '1' },
    //     { title: '禁用', value: '0' }
    //   ]
    // },
    {
      field: 'createdTime',
      type: 'datepicker',
      label: '创建时间',
      otherOptions: {
        startPlaceholder: '开始时间',
        endPlaceholder: '结束时间',
        type: 'daterange',
        'value-format': 'YYYY-MM-DD',
        disabledDate: (date: Date) => {
          return new Date() < date
        }
      }
    }
  ]
}
